<template>
  <div class="chartBox pb1x" :class="chartClass">
    <Loading ref="loading"></Loading>
    <div v-if="data&&data.length>0" :class="chartClass" class="chart pt1x pl1x pr1x"></div>
    <NoResult v-if="data&&data.length==0" :class="chartClass"></NoResult>
  </div>
</template>
<script>
import * as lib from '@/util/lib.js'
import Loading from '@/components/common/ui/Loading.vue'
import NoResult from '@/components/common/ui/NoResult.vue'
import { drawLine } from '@/util/chart.js'
export default {
  name: 'ChartLine',
  components: { Loading, NoResult },
  props: {
    data: {
      type: Array,
      default: null
    },
    option: {
      type: Object,
      default: function () {
        return {
          yTitle: ['']
        }
      }
    },
    chartClass: {// 图表需要的class
      type: String,
      default: ''
    }
  },
  data () {
    return {
      // id:"chartLine"+Math.round(Math.random()*99999)
    }
  },
  watch: {
    data: function (data) {
      this.run()
    }
  },
  methods: {
    rebuildData (data, option) {
      let resultData = null
      if (data && option) {
        // option.yTitle = []
        resultData = data.map(item => {
          if (item.unit && lib.unitinclude(item.unit) && item.data.length) {
            // if (option.yTitle.indexOf(item.unit) !== -1) option.yTitle.splice(option.yTitle.indexOf(item.unit), 1)

            // console.log(item.unit.length, item.unit)
            let dataitem = this.changeUnit(item.data, item.unit.length > 1 ? item.unit.substr(0, 1) : item.unit, item.unit.length > 1 ? item.unit.substr(1, item.unit.length) : item.unit)
            // console.log(dataitem)
            option.yTitle.includes(dataitem[0][2]) ? option.yTitle = _.cloneDeep(option.yTitle) : option.yTitle.push(dataitem[0][2] ? dataitem[0][2] : item.unit)
            item.unit = dataitem[0][2]
            item.data = dataitem[1]
            return item
          } else {
            option.yTitle.includes(item.unit) ? option.yTitle = _.cloneDeep(option.yTitle) : option.yTitle.push(item.unit)
          }
          return item
        })
      }
      // option.yTitle = option.yTitle.filter(item=>{
      //   return item
      // })
      // console.log(option.yTitle)
      // option.yTitle = Array.from(new Set(option.yTitle))
      let usedUnit = resultData.map(item => {
        return item.unit
      })
      option.yTitle = Array.from(new Set(option.yTitle))
      option.yTitle = option.yTitle.filter(item => {
        return usedUnit.includes(item)
      })
      resultData.map(item => {
        item.yAxis = option.yTitle.indexOf(item.unit)
        item.yAxis = item.yAxis !== -1 ? item.yAxis : 0
      })
      //  console.log(resultData,option.yTitle)
      return [resultData || data, option]
    },
    changeUnit (data, origin, initNine) {
      // console.log(initNine)
      let max = data.reduce((item1, item2) => {
        return Math.abs(item1[1]) >= Math.abs(item2[1]) ? item1 : item2
      })
      let copyMax = _.cloneDeep(max)
      // console.log(this.convertData(max.generationValue, 2, 'k', 'Wh', false)[2])
      let unit = origin === 'W' ? 'W' : lib.convertData(max[1], 2, origin, initNine, false)[2] ? lib.convertData(max[1], 2, origin, initNine, false)[2].substr(0, 1) : ''
      // console.log(unit)
      let resdata = data.map(item => {
        if (unit === 'k') {
          let datas = lib.floatFix(Number(item[1]), 2, null, true, false)
          item[1] = datas === '--' ? null : datas
        } else if (unit === 'M') {
          let datas = lib.floatFix(Number(item[1]) / 1000, 2, null, true, false)
          item[1] = datas === '--' ? null : datas
          // console.log(item[1])
        } else if (unit === 'G') {
          let datas = lib.floatFix(Number(item[1]) / 1000000, 2, null, true, false)
          item[1] = datas === '--' ? null : datas
        } else if (unit === 'W') {
          if (copyMax[1] > 1000000000 || copyMax[1] < -1000000000) {
            let datas = lib.floatFix((item[1] / 1000000000), 2, null, true, false)
            item[1] = datas === '--' ? null : datas
          } else if (copyMax[1] > 1000000 || copyMax[1] < -1000000) {
            let datas = lib.floatFix((item[1] / 1000000), 2, null, true, false)
            item[1] = datas === '--' ? null : datas
          } else if (copyMax[1] > 1000 || copyMax[1] < -1000) {
            let datas = lib.floatFix(item[1] / 1000, 2, null, true, false)
            item[1] = datas === '--' ? null : datas
          } else {
            let datas = lib.floatFix(item[1], 2, null, true, false)
            item[1] = datas === '--' ? null : datas
          }
        }

        return item
        // item.generationValue = this.convertData(item.generationValue * 1000, null, 'k', 'Wh', false)
      })
      if (unit === 'W') {
        return [[copyMax[1] + this.wunit(copyMax[1]) + 'W', copyMax[1], this.wunit(copyMax[1]) + 'W'], resdata]
      } else {
        return [lib.convertData(copyMax[1], 2, origin, initNine, false), resdata]
      }
    },
    wunit (data) {
      if (data > 1000000000 || data < -1000000000) return 'G'
      else if (data > 1000000 || data < -1000000) return 'M'
      else if (data > 1000 || data < -1000) return 'k'
      else return ''
    },
    run: function () {
      this.$nextTick(function () {
        // $("#"+this.id).addClass(this.sizeClass);
        if (this.data) {
          // console.log(this.data)
          this.hideLoading()
          if (this.data.length > 0) {
            if (!this.option.dataHover) {
              this.option.dataHover = data => { // 判断并追加数据交互输出
                this.$emit('DataHover', data)
              }
            }
            // console.log(this.data, this.option)
            // console.log( _.cloneDeep(this.option))
            let arrres = this.rebuildData(_.cloneDeep(this.data), _.cloneDeep(this.option))
            let rd = arrres[0]
            let opt = arrres[1]
            opt.spacing = [0, 0, 0, 7]

            drawLine($(this.$el).find('.chart')[0], rd, opt)
          }
        } else {
          this.showLoading()
        }
      })
    },
    showLoading () {
      this.$refs.loading.show()
    },
    hideLoading () {
      this.$refs.loading.hide()
    }
  },
  created () { },
  mounted () {
    // trace(this.data)
  }
}
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/common/chart/ChartLine.vue